import { loginValidation } from '@alluradirect/react';
import { LoginForm, LoginFormProps } from 'components/views/pages/login/LoginForm';
import { Formik, Form, FormikHelpers } from 'formik';

const initialLoginFormValues = {
  email: '',
  password: '',
  submit: '',
};

export type LoginFormikValues = typeof initialLoginFormValues;

interface Props {
  onSubmit: (values: LoginFormikValues, helpers: FormikHelpers<LoginFormikValues>) => Promise<any>;
  initialValues?: LoginFormikValues;
}

export const LoginFormikForm = ({ onSubmit, initialValues, ...rest }: Props & LoginFormProps) => {
  const initValues = initialValues ?? initialLoginFormValues;

  return (
    <Formik onSubmit={onSubmit} initialValues={initValues} validationSchema={loginValidation}>
      <Form>
        <LoginForm {...rest} />
      </Form>
    </Formik>
  );
};
